import { render } from "./TabHeader.vue?vue&type=template&id=b393b124&scoped=true"
import script from "./TabHeader.vue?vue&type=script&lang=js"
export * from "./TabHeader.vue?vue&type=script&lang=js"

import "./TabHeader.vue?vue&type=style&index=0&id=b393b124&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b393b124"]])

export default __exports__